/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetVarietiesParams,
  HTTPValidationError,
  VarietyCreate,
  VarietyResponse,
  VarietyUpdate,
} from "../model";

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getVarietiesResponse200 = {
  data: VarietyResponse[];
  status: 200;
};

export type getVarietiesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getVarietiesResponseSuccess = getVarietiesResponse200 & {
  headers: Headers;
};
export type getVarietiesResponseError = getVarietiesResponse422 & {
  headers: Headers;
};

export type getVarietiesResponse =
  getVarietiesResponseSuccess | getVarietiesResponseError;

export const getGetVarietiesUrl = (params?: GetVarietiesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/varieties/?${stringifiedParams}`
    : `/api/varieties/`;
};

/**
 * @summary Get Varieties Route
 */
export const getVarieties = async (
  params?: GetVarietiesParams,
  options?: RequestInit,
): Promise<getVarietiesResponse> => {
  const res = await fetch(getGetVarietiesUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getVarietiesResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getVarietiesResponse;
};

export const getGetVarietiesQueryKey = (params?: GetVarietiesParams) => {
  return [`/api/varieties/`, ...(params ? [params] : [])] as const;
};

export const getGetVarietiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getVarieties>>,
  TError = HTTPValidationError,
>(
  params?: GetVarietiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVarieties>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVarietiesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVarieties>>> = ({
    signal,
  }) => getVarieties(params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVarieties>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetVarietiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVarieties>>
>;
export type GetVarietiesQueryError = HTTPValidationError;

export function useGetVarieties<
  TData = Awaited<ReturnType<typeof getVarieties>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetVarietiesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVarieties>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVarieties>>,
          TError,
          Awaited<ReturnType<typeof getVarieties>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVarieties<
  TData = Awaited<ReturnType<typeof getVarieties>>,
  TError = HTTPValidationError,
>(
  params?: GetVarietiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVarieties>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVarieties>>,
          TError,
          Awaited<ReturnType<typeof getVarieties>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVarieties<
  TData = Awaited<ReturnType<typeof getVarieties>>,
  TError = HTTPValidationError,
>(
  params?: GetVarietiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVarieties>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Varieties Route
 */

export function useGetVarieties<
  TData = Awaited<ReturnType<typeof getVarieties>>,
  TError = HTTPValidationError,
>(
  params?: GetVarietiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVarieties>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetVarietiesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createVarietyResponse200 = {
  data: VarietyResponse;
  status: 200;
};

export type createVarietyResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createVarietyResponseSuccess = createVarietyResponse200 & {
  headers: Headers;
};
export type createVarietyResponseError = createVarietyResponse422 & {
  headers: Headers;
};

export type createVarietyResponse =
  createVarietyResponseSuccess | createVarietyResponseError;

export const getCreateVarietyUrl = () => {
  return `/api/varieties/`;
};

/**
 * @summary Create Variety Route
 */
export const createVariety = async (
  varietyCreate: VarietyCreate,
  options?: RequestInit,
): Promise<createVarietyResponse> => {
  const res = await fetch(getCreateVarietyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(varietyCreate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createVarietyResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as createVarietyResponse;
};

export const getCreateVarietyMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVariety>>,
    TError,
    { data: VarietyCreate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVariety>>,
  TError,
  { data: VarietyCreate },
  TContext
> => {
  const mutationKey = ["createVariety"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVariety>>,
    { data: VarietyCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createVariety(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVarietyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVariety>>
>;
export type CreateVarietyMutationBody = VarietyCreate;
export type CreateVarietyMutationError = HTTPValidationError;

/**
 * @summary Create Variety Route
 */
export const useCreateVariety = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createVariety>>,
      TError,
      { data: VarietyCreate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createVariety>>,
  TError,
  { data: VarietyCreate },
  TContext
> => {
  return useMutation(getCreateVarietyMutationOptions(options), queryClient);
};
export type getVarietyResponse200 = {
  data: VarietyResponse;
  status: 200;
};

export type getVarietyResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getVarietyResponseSuccess = getVarietyResponse200 & {
  headers: Headers;
};
export type getVarietyResponseError = getVarietyResponse422 & {
  headers: Headers;
};

export type getVarietyResponse =
  getVarietyResponseSuccess | getVarietyResponseError;

export const getGetVarietyUrl = (varietyId: number) => {
  return `/api/varieties/${varietyId}`;
};

/**
 * @summary Get Variety Route
 */
export const getVariety = async (
  varietyId: number,
  options?: RequestInit,
): Promise<getVarietyResponse> => {
  const res = await fetch(getGetVarietyUrl(varietyId), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getVarietyResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getVarietyResponse;
};

export const getGetVarietyQueryKey = (varietyId: number) => {
  return [`/api/varieties/${varietyId}`] as const;
};

export const getGetVarietyQueryOptions = <
  TData = Awaited<ReturnType<typeof getVariety>>,
  TError = HTTPValidationError,
>(
  varietyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVariety>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVarietyQueryKey(varietyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVariety>>> = ({
    signal,
  }) => getVariety(varietyId, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: varietyId !== null && varietyId !== undefined,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVariety>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetVarietyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVariety>>
>;
export type GetVarietyQueryError = HTTPValidationError;

export function useGetVariety<
  TData = Awaited<ReturnType<typeof getVariety>>,
  TError = HTTPValidationError,
>(
  varietyId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVariety>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVariety>>,
          TError,
          Awaited<ReturnType<typeof getVariety>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVariety<
  TData = Awaited<ReturnType<typeof getVariety>>,
  TError = HTTPValidationError,
>(
  varietyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVariety>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVariety>>,
          TError,
          Awaited<ReturnType<typeof getVariety>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVariety<
  TData = Awaited<ReturnType<typeof getVariety>>,
  TError = HTTPValidationError,
>(
  varietyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVariety>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Variety Route
 */

export function useGetVariety<
  TData = Awaited<ReturnType<typeof getVariety>>,
  TError = HTTPValidationError,
>(
  varietyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVariety>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetVarietyQueryOptions(varietyId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateVarietyResponse200 = {
  data: VarietyResponse;
  status: 200;
};

export type updateVarietyResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateVarietyResponseSuccess = updateVarietyResponse200 & {
  headers: Headers;
};
export type updateVarietyResponseError = updateVarietyResponse422 & {
  headers: Headers;
};

export type updateVarietyResponse =
  updateVarietyResponseSuccess | updateVarietyResponseError;

export const getUpdateVarietyUrl = (varietyId: number) => {
  return `/api/varieties/${varietyId}`;
};

/**
 * @summary Update Variety Route
 */
export const updateVariety = async (
  varietyId: number,
  varietyUpdate: VarietyUpdate,
  options?: RequestInit,
): Promise<updateVarietyResponse> => {
  const res = await fetch(getUpdateVarietyUrl(varietyId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(varietyUpdate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateVarietyResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as updateVarietyResponse;
};

export const getUpdateVarietyMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVariety>>,
    TError,
    { varietyId: number; data: VarietyUpdate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVariety>>,
  TError,
  { varietyId: number; data: VarietyUpdate },
  TContext
> => {
  const mutationKey = ["updateVariety"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVariety>>,
    { varietyId: number; data: VarietyUpdate }
  > = (props) => {
    const { varietyId, data } = props ?? {};

    return updateVariety(varietyId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVarietyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVariety>>
>;
export type UpdateVarietyMutationBody = VarietyUpdate;
export type UpdateVarietyMutationError = HTTPValidationError;

/**
 * @summary Update Variety Route
 */
export const useUpdateVariety = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateVariety>>,
      TError,
      { varietyId: number; data: VarietyUpdate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateVariety>>,
  TError,
  { varietyId: number; data: VarietyUpdate },
  TContext
> => {
  return useMutation(getUpdateVarietyMutationOptions(options), queryClient);
};
export type deleteVarietyResponse200 = {
  data: VarietyResponse;
  status: 200;
};

export type deleteVarietyResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteVarietyResponseSuccess = deleteVarietyResponse200 & {
  headers: Headers;
};
export type deleteVarietyResponseError = deleteVarietyResponse422 & {
  headers: Headers;
};

export type deleteVarietyResponse =
  deleteVarietyResponseSuccess | deleteVarietyResponseError;

export const getDeleteVarietyUrl = (varietyId: number) => {
  return `/api/varieties/${varietyId}`;
};

/**
 * Set ``is_active=False`` and record ``user_id`` (row is kept).
 * @summary Delete Variety Route
 */
export const deleteVariety = async (
  varietyId: number,
  options?: RequestInit,
): Promise<deleteVarietyResponse> => {
  const res = await fetch(getDeleteVarietyUrl(varietyId), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteVarietyResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as deleteVarietyResponse;
};

export const getDeleteVarietyMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVariety>>,
    TError,
    { varietyId: number },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVariety>>,
  TError,
  { varietyId: number },
  TContext
> => {
  const mutationKey = ["deleteVariety"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVariety>>,
    { varietyId: number }
  > = (props) => {
    const { varietyId } = props ?? {};

    return deleteVariety(varietyId, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVarietyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVariety>>
>;

export type DeleteVarietyMutationError = HTTPValidationError;

/**
 * @summary Delete Variety Route
 */
export const useDeleteVariety = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteVariety>>,
      TError,
      { varietyId: number },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteVariety>>,
  TError,
  { varietyId: number },
  TContext
> => {
  return useMutation(getDeleteVarietyMutationOptions(options), queryClient);
};
